module.exports = __webpack_public_path__ + "static/img/icon1.f4c40999.png";